import { useMemo } from "react";
import { useAccountAccesses } from "@/hooks/useAccountAccesses";
import { useAuth } from "@/core/hooks/useAuth";
import { DocID } from "@/types";

/**
 * Hook to check if the current user has admin access in at least one sector of a given company.
 * This mirrors the logic in backstrapi/src/middlewares/verify-company-admin-access.ts
 */
export const useIsCompanyAdmin = (companyId?: DocID | null) => {
  const { data: accountAccesses = [] } = useAccountAccesses();
  const { user } = useAuth();
  const isDev = Boolean(user?.isDev);

  const isCompanyAdmin = useMemo(() => {
    if (!companyId) return false;
    // SA-1482: a role dev faz tudo que o admin da empresa faz, em toda empresa
    // (o backend reconfere em verify-company-admin-access).
    if (isDev) return true;

    return accountAccesses.some(
      (access) =>
        access.company.documentId === companyId && access.role === "admin"
    );
  }, [accountAccesses, companyId, isDev]);

  return isCompanyAdmin;
};
